import { CdnUrl } from "../../../common/constants";
import { combineAddress, isNothing } from "../../../common/utils";

export const HeaderLinkMenuIcon: React.FC<{
    className?: string
}> = ({ className }) => {
    return <svg className={`${className} `} xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
        <g filter="url(#filter0_d_424_434)">
            <path d="M11 17L4.93782 6.5L17.0622 6.5L11 17Z" fill="white" />
        </g>
        <defs>
            <filter id="filter0_d_424_434" x="0.9375" y="3.5" width="20.125" height="18.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_424_434" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_424_434" result="shape" />
            </filter>
        </defs>
    </svg>;
};

export const SocialIcon: React.FC<{
    className?: string;
    imageClassName?: string
    type: SocialType;
    isActive: boolean;
    isLive?: boolean;
    onlyLive?: boolean
}> = ({ className, type, isActive, isLive, onlyLive, imageClassName }) => {
    const state = isActive && (isNothing(onlyLive) || (onlyLive && isLive)) ? "active" : "disabled";

    const showLiveIndicator = isLive && (type === "twitch" || type === "youtube");
    const liveColor =
        type === "twitch"
            ? "bg-[rgba(100,65,165,0.90)]"
            : type === "youtube"
                ? "bg-[rgba(230,0,0,0.50)]"
                : "";

    const src = combineAddress(CdnUrl, `/v2/images/social/${type}-${state}.svg`)

    return (
        <div
            className={`flex relative items-center inline-block w-[24px] h-[24px] lg:w-[32px] lg:h-[32px] ${className ?? ""}`}
        >
            {showLiveIndicator && (
                <span
                    className={`absolute inset-0 rounded-[42px] ${liveColor} animate-ping duration-[2000ms]`}
                    style={{ zIndex: 0 }}
                />
            )}


            <img
                className={`w-full h-full object-contain relative z-10 ${state !== "disabled" ? "hover:brightness-[120%]" : ""} ${imageClassName || ''}`}
                src={src}
                alt={`${type} icon`}
            />
        </div>
    );
};



export const UpdateGroupTitleIcon: React.FC<{
    className?: string
}> = ({ className }) => {
    return <svg className={`${className} `} xmlns="http://www.w3.org/2000/svg" width="3" height="50" viewBox="0 0 3 50" fill="none">
        <rect width="2" height="22" fill="#81E8F8" />
        <rect y="28" width="2" height="22" fill="#81E8F8" />
        <path d="M3 25L3.01992e-07 27L2.38419e-07 23L3 25Z" fill="#81E8F8" />
    </svg>
};

export const LanguageIcon: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <div className={`relative group w-[32px] h-[32px]  ${className}`}>
            <img
                src="/images/lang.svg"
                className="absolute inset-0 transition-opacity group-hover:opacity-0"
            />
            <img
                src="/images/lang-hover.svg"
                className="absolute inset-0 opacity-0 transition-opacity group-hover:opacity-100"
            />
        </div>
    );
};


export const LogoutIcon: React.FC<{
    className?: string
}> = ({ className }) => {
    return <svg className={`${className} `} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#BAC1D3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 17L21 12L16 7" stroke="#BAC1D3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21 12H9" stroke="#BAC1D3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
};

export const EditProfileIcon: React.FC<{
    className?: string
}> = ({ className }) => {
    return <svg className={` ${className}`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clipPath="url(#clip0_561_7047)">
            <path d="M14.166 2.5C14.3849 2.28113 14.6447 2.10752 14.9307 1.98906C15.2167 1.87061 15.5232 1.80965 15.8327 1.80965C16.1422 1.80965 16.4487 1.87061 16.7347 1.98906C17.0206 2.10752 17.2805 2.28113 17.4993 2.5C17.7182 2.71887 17.8918 2.97871 18.0103 3.26468C18.1287 3.55064 18.1897 3.85714 18.1897 4.16667C18.1897 4.4762 18.1287 4.7827 18.0103 5.06866C17.8918 5.35463 17.7182 5.61447 17.4993 5.83334L6.24935 17.0833L1.66602 18.3333L2.91602 13.75L14.166 2.5Z" stroke="#5A6A74" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_561_7047">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
};

export const CloseIcon: React.FC<{
    className?: string
}> = ({ className }) => {
    return <svg className={`${className || ''}`} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M24 8L8 24" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 8L24 24" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}

export const PaginationIcon: React.FC<{
    className?: string,
    isNext: boolean
}> = ({ className, isNext }) => {
    return (
        <svg
            className={`${className ?? ''} ${!isNext ? 'rotate-180' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.21967 3.21967C6.51256 2.92678 6.98744 2.92678 7.28033 3.21967L11.5303 7.46967C11.8232 7.76256 11.8232 8.23744 11.5303 8.53033L7.28033 12.7803C6.98744 13.0732 6.51256 13.0732 6.21967 12.7803C5.92678 12.4874 5.92678 12.0126 6.21967 11.7197L9.93934 8L6.21967 4.28033C5.92678 3.98744 5.92678 3.51256 6.21967 3.21967Z"
                fill="url(#paint0_linear_567_4216)"
            />
            <defs>
                <linearGradient id="paint0_linear_567_4216" x1="11.75" y1="7.99998" x2="6" y2="7.99998" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFB530" />
                    <stop offset="1" stopColor="#F3813C" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const SearchIcon: React.FC<{
    className?: string,
}> = ({ className }) => {
    return <svg className={` ${className ?? ''}`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M15.2544 14.0683L11.7231 10.5361C12.5243 9.4854 13 8.17325 13 6.75C13 3.29822 10.2018 0.5 6.75 0.5C3.29822 0.5 0.5 3.29822 0.5 6.75C0.5 10.2018 3.29822 13 6.75 13C8.17346 13 9.48577 12.5241 10.5365 11.7228L14.0679 15.2552C14.3949 15.5823 14.9253 15.5814 15.253 15.2537C15.5829 14.9237 15.5813 14.3953 15.2544 14.0683ZM11.3333 6.75C11.3333 9.28131 9.28131 11.3333 6.75 11.3333C4.21869 11.3333 2.16667 9.28131 2.16667 6.75C2.16667 4.21869 4.21869 2.16667 6.75 2.16667C9.28131 2.16667 11.3333 4.21869 11.3333 6.75Z" fill="white" />
    </svg>
}


export const CooldownIcon: React.FC<{
    className?: string,
}> = ({ className }) => {
    return <svg className={` ${className ?? ''}`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_804_22458)">
            <rect width="16" height="16" fill="#E5E5E6" />
            <path d="M8 8.5V-0.5V-1H-1V16.5H17L8 8.5Z" fill="#434345" stroke="#434345" />
        </g>
        <defs>
            <clipPath id="clip0_804_22458">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
}

export const ManaIcon: React.FC<{
    className?: string,
}> = ({ className }) => {
    return <svg className={` ${className ?? ''}`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect width="16" height="16" fill="#068EBC" />
    </svg>
}

export const SelectIcon: React.FC<{
    className?: string,
    isOpen: boolean
}> = ({ className, isOpen }) => {
    return (
        <svg
            className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''} ${className ?? ''}`}
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
        >
            <path d="M0.5733 0.494077C0.902154 0.168639 1.43533 0.168639 1.76419 0.494077L7.06333 5.73815L12.3625 0.494076C12.6913 0.168639 13.2245 0.168639 13.5534 0.494076C13.8822 0.819513 13.8822 1.34715 13.5534 1.67259L7.65877 7.50592C7.32992 7.83136 6.79674 7.83136 6.46788 7.50592L0.5733 1.67259C0.244446 1.34715 0.244446 0.819513 0.5733 0.494077Z" fill="white" />
        </svg>
    );
};

export const SortIcon: React.FC<{
    className?: string;
    dir?: 'asc' | 'desc';
}> = ({ className, dir }) => {
    return (
        <div className={`flex flex-col items-center gap-[2px] ${className ?? ''}`}>
            <img
                src={dir === 'asc' ? '/images/sort-b-orange.svg' : '/images/sort-b-gray.svg'}
                className="w-[10px] rotate-180"
                alt="Sort Asc"
            />
            <img
                src={dir === 'desc' ? '/images/sort-b-orange.svg' : '/images/sort-b-gray.svg'}
                className="w-[10px]"
                alt="Sort Desc"
            />
        </div>
    );
};

export const NavMenuIcon: React.FC<{
    className?: string
    isActive: boolean
}> = ({ className, isActive }) => {
    return isActive
        ? <svg className={`${className || ''}`} xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
            <g clip-path="url(#clip0_1503_11549)">
                <g filter="url(#filter0_d_1503_11549)">
                    <path d="M5.75 34.5H40.25V30.6667H5.75V34.5ZM5.75 24.9167H40.25V21.0833H5.75V24.9167ZM5.75 11.5V15.3333H40.25V11.5H5.75Z" fill="url(#paint0_linear_1503_11549)" />
                </g>
            </g>
            <defs>
                <filter id="filter0_d_1503_11549" x="1.75" y="8.5" width="42.5" height="31" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1503_11549" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1503_11549" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_1503_11549" x1="40.25" y1="23" x2="5.75" y2="23" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FB8C07" />
                    <stop offset="1" stop-color="#F16621" />
                </linearGradient>
                <clipPath id="clip0_1503_11549">
                    <rect width="46" height="46" fill="white" />
                </clipPath>
            </defs>
        </svg>
        : <svg className={`${className || ''}`} xmlns="http://www.w3.org/2000/svg" width="44" height="32" viewBox="0 0 44 32" fill="none">
            <g filter="url(#filter0_d_804_24432)">
                <path d="M4.75 26.5H39.25V22.6667H4.75V26.5ZM4.75 16.9167H39.25V13.0833H4.75V16.9167ZM4.75 3.5V7.33333H39.25V3.5H4.75Z" fill="white" />
            </g>
            <defs>
                <filter id="filter0_d_804_24432" x="0.75" y="0.5" width="42.5" height="31" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_804_24432" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_804_24432" result="shape" />
                </filter>
            </defs>
        </svg>
}

export const LoadingIcon: React.FC<{
    className?: string
}> = ({ className }) => {

    return <div className={`mx-auto ${className || ''} h-fit animate-spin-slow max-w-[350px] max-h-[350px]`}>
        <svg style={{ width: '100%', height: '100%' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <g data-idx="1"><g transform="matrix(-1,0,0,1,100,0)" data-idx="2"><g data-idx="3" transform="matrix(0.88945303627131,-0.4570265815767697,0.4570265815767697,0.88945303627131,-17.32398089240398,28.378677265272984)">
            <path d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z" fill="#e07e3f" data-idx="5"></path>
            <path d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z" fill="#9c61d9" data-idx="6"></path>
            <path d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z" fill="#4c80d6" data-idx="7"></path></g><g data-idx="8"></g></g></g>
        </svg >
    </div>
}